import store from "../store";

export default async function is_admin_and_tester({ next, router }) {
    await store.dispatch('profile/role');
    let role = await store.getters['profile/role'];
    if ( (role !== 'mini-admin') && (role !== 'admin') && (role !== 'tester') ) {
        return router.push({ name: "User Profile" });
    }

    return next();
}
